import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EpocusProgramUsersQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
}>;


export type EpocusProgramUsersQuery = { readonly __typename?: 'Query', readonly listProgramUsers: ReadonlyArray<{ readonly __typename?: 'EpocusProgramMembership', readonly id: string, readonly epocusUserId: string, readonly role: Types.EpocusRole, readonly user: { readonly __typename?: 'EpocusUser', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly telephone?: string | null, readonly status: Types.EpocusUserStatus } }> };

export type EpocusCreateUserMutationVariables = Types.Exact<{
  input: Types.ProvisionEpocusProgramMemberInput;
}>;


export type EpocusCreateUserMutation = { readonly __typename?: 'Mutation', readonly provisionEpocusProgramMember: { readonly __typename?: 'EpocusProgramMembership', readonly id: string } };

export type EpocusUpdateUserMutationVariables = Types.Exact<{
  input: Types.UpdateEpocusUserInput;
}>;


export type EpocusUpdateUserMutation = { readonly __typename?: 'Mutation', readonly updateEpocusUser: { readonly __typename?: 'EpocusUser', readonly id: string, readonly firstName: string, readonly lastName: string, readonly telephone?: string | null } };

export type EpocusSetUserEnabledMutationVariables = Types.Exact<{
  epocusUserId: Types.Scalars['ID'];
  enabled: Types.Scalars['Boolean'];
}>;


export type EpocusSetUserEnabledMutation = { readonly __typename?: 'Mutation', readonly setEpocusUserEnabled: { readonly __typename?: 'EpocusUser', readonly id: string, readonly status: Types.EpocusUserStatus } };

export type EpocusResetUserMfaMutationVariables = Types.Exact<{
  epocusUserId: Types.Scalars['ID'];
}>;


export type EpocusResetUserMfaMutation = { readonly __typename?: 'Mutation', readonly resetEpocusUserMfa: boolean };

export type EpocusSendUserPasswordResetMutationVariables = Types.Exact<{
  epocusUserId: Types.Scalars['ID'];
}>;


export type EpocusSendUserPasswordResetMutation = { readonly __typename?: 'Mutation', readonly sendEpocusUserPasswordReset: boolean };


export const EpocusProgramUsersDocument = gql`
    query EpocusProgramUsers($programId: ID!) {
  listProgramUsers(programId: $programId) {
    id
    epocusUserId
    role
    user {
      id
      firstName
      lastName
      email
      telephone
      status
    }
  }
}
    `;

/**
 * __useEpocusProgramUsersQuery__
 *
 * To run a query within a React component, call `useEpocusProgramUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusProgramUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusProgramUsersQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useEpocusProgramUsersQuery(baseOptions: Apollo.QueryHookOptions<EpocusProgramUsersQuery, EpocusProgramUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusProgramUsersQuery, EpocusProgramUsersQueryVariables>(EpocusProgramUsersDocument, options);
      }
export function useEpocusProgramUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusProgramUsersQuery, EpocusProgramUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusProgramUsersQuery, EpocusProgramUsersQueryVariables>(EpocusProgramUsersDocument, options);
        }
export type EpocusProgramUsersQueryHookResult = ReturnType<typeof useEpocusProgramUsersQuery>;
export type EpocusProgramUsersLazyQueryHookResult = ReturnType<typeof useEpocusProgramUsersLazyQuery>;
export type EpocusProgramUsersQueryResult = Apollo.QueryResult<EpocusProgramUsersQuery, EpocusProgramUsersQueryVariables>;
export const EpocusCreateUserDocument = gql`
    mutation EpocusCreateUser($input: ProvisionEpocusProgramMemberInput!) {
  provisionEpocusProgramMember(input: $input) {
    id
  }
}
    `;
export type EpocusCreateUserMutationFn = Apollo.MutationFunction<EpocusCreateUserMutation, EpocusCreateUserMutationVariables>;

/**
 * __useEpocusCreateUserMutation__
 *
 * To run a mutation, you first call `useEpocusCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEpocusCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [epocusCreateUserMutation, { data, loading, error }] = useEpocusCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEpocusCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<EpocusCreateUserMutation, EpocusCreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EpocusCreateUserMutation, EpocusCreateUserMutationVariables>(EpocusCreateUserDocument, options);
      }
export type EpocusCreateUserMutationHookResult = ReturnType<typeof useEpocusCreateUserMutation>;
export type EpocusCreateUserMutationResult = Apollo.MutationResult<EpocusCreateUserMutation>;
export type EpocusCreateUserMutationOptions = Apollo.BaseMutationOptions<EpocusCreateUserMutation, EpocusCreateUserMutationVariables>;
export const EpocusUpdateUserDocument = gql`
    mutation EpocusUpdateUser($input: UpdateEpocusUserInput!) {
  updateEpocusUser(input: $input) {
    id
    firstName
    lastName
    telephone
  }
}
    `;
export type EpocusUpdateUserMutationFn = Apollo.MutationFunction<EpocusUpdateUserMutation, EpocusUpdateUserMutationVariables>;

/**
 * __useEpocusUpdateUserMutation__
 *
 * To run a mutation, you first call `useEpocusUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEpocusUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [epocusUpdateUserMutation, { data, loading, error }] = useEpocusUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEpocusUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<EpocusUpdateUserMutation, EpocusUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EpocusUpdateUserMutation, EpocusUpdateUserMutationVariables>(EpocusUpdateUserDocument, options);
      }
export type EpocusUpdateUserMutationHookResult = ReturnType<typeof useEpocusUpdateUserMutation>;
export type EpocusUpdateUserMutationResult = Apollo.MutationResult<EpocusUpdateUserMutation>;
export type EpocusUpdateUserMutationOptions = Apollo.BaseMutationOptions<EpocusUpdateUserMutation, EpocusUpdateUserMutationVariables>;
export const EpocusSetUserEnabledDocument = gql`
    mutation EpocusSetUserEnabled($epocusUserId: ID!, $enabled: Boolean!) {
  setEpocusUserEnabled(epocusUserId: $epocusUserId, enabled: $enabled) {
    id
    status
  }
}
    `;
export type EpocusSetUserEnabledMutationFn = Apollo.MutationFunction<EpocusSetUserEnabledMutation, EpocusSetUserEnabledMutationVariables>;

/**
 * __useEpocusSetUserEnabledMutation__
 *
 * To run a mutation, you first call `useEpocusSetUserEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEpocusSetUserEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [epocusSetUserEnabledMutation, { data, loading, error }] = useEpocusSetUserEnabledMutation({
 *   variables: {
 *      epocusUserId: // value for 'epocusUserId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useEpocusSetUserEnabledMutation(baseOptions?: Apollo.MutationHookOptions<EpocusSetUserEnabledMutation, EpocusSetUserEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EpocusSetUserEnabledMutation, EpocusSetUserEnabledMutationVariables>(EpocusSetUserEnabledDocument, options);
      }
export type EpocusSetUserEnabledMutationHookResult = ReturnType<typeof useEpocusSetUserEnabledMutation>;
export type EpocusSetUserEnabledMutationResult = Apollo.MutationResult<EpocusSetUserEnabledMutation>;
export type EpocusSetUserEnabledMutationOptions = Apollo.BaseMutationOptions<EpocusSetUserEnabledMutation, EpocusSetUserEnabledMutationVariables>;
export const EpocusResetUserMfaDocument = gql`
    mutation EpocusResetUserMfa($epocusUserId: ID!) {
  resetEpocusUserMfa(epocusUserId: $epocusUserId)
}
    `;
export type EpocusResetUserMfaMutationFn = Apollo.MutationFunction<EpocusResetUserMfaMutation, EpocusResetUserMfaMutationVariables>;

/**
 * __useEpocusResetUserMfaMutation__
 *
 * To run a mutation, you first call `useEpocusResetUserMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEpocusResetUserMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [epocusResetUserMfaMutation, { data, loading, error }] = useEpocusResetUserMfaMutation({
 *   variables: {
 *      epocusUserId: // value for 'epocusUserId'
 *   },
 * });
 */
export function useEpocusResetUserMfaMutation(baseOptions?: Apollo.MutationHookOptions<EpocusResetUserMfaMutation, EpocusResetUserMfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EpocusResetUserMfaMutation, EpocusResetUserMfaMutationVariables>(EpocusResetUserMfaDocument, options);
      }
export type EpocusResetUserMfaMutationHookResult = ReturnType<typeof useEpocusResetUserMfaMutation>;
export type EpocusResetUserMfaMutationResult = Apollo.MutationResult<EpocusResetUserMfaMutation>;
export type EpocusResetUserMfaMutationOptions = Apollo.BaseMutationOptions<EpocusResetUserMfaMutation, EpocusResetUserMfaMutationVariables>;
export const EpocusSendUserPasswordResetDocument = gql`
    mutation EpocusSendUserPasswordReset($epocusUserId: ID!) {
  sendEpocusUserPasswordReset(epocusUserId: $epocusUserId)
}
    `;
export type EpocusSendUserPasswordResetMutationFn = Apollo.MutationFunction<EpocusSendUserPasswordResetMutation, EpocusSendUserPasswordResetMutationVariables>;

/**
 * __useEpocusSendUserPasswordResetMutation__
 *
 * To run a mutation, you first call `useEpocusSendUserPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEpocusSendUserPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [epocusSendUserPasswordResetMutation, { data, loading, error }] = useEpocusSendUserPasswordResetMutation({
 *   variables: {
 *      epocusUserId: // value for 'epocusUserId'
 *   },
 * });
 */
export function useEpocusSendUserPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<EpocusSendUserPasswordResetMutation, EpocusSendUserPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EpocusSendUserPasswordResetMutation, EpocusSendUserPasswordResetMutationVariables>(EpocusSendUserPasswordResetDocument, options);
      }
export type EpocusSendUserPasswordResetMutationHookResult = ReturnType<typeof useEpocusSendUserPasswordResetMutation>;
export type EpocusSendUserPasswordResetMutationResult = Apollo.MutationResult<EpocusSendUserPasswordResetMutation>;
export type EpocusSendUserPasswordResetMutationOptions = Apollo.BaseMutationOptions<EpocusSendUserPasswordResetMutation, EpocusSendUserPasswordResetMutationVariables>;